// extracted by mini-css-extract-plugin
module.exports = {"customFieldDraggable":"CustomFieldRenderUtils_customFieldDraggable__15-hX"};